import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { PasswordInput } from "@/components/Layout";
import MfaCodeForm from "@/components/MfaCodeForm";
import { takeLoginNotice } from "@/lib/api";
import logo from "@/assets/HR.png";
import { loadPlatformVersion } from "@/lib/version";
import { GDPR_TEXT_VERSION } from "@/lib/gdpr";

/** Autentificarea în aspectul Fiord: un card curat, centrat, pe fundal turcoaz-gri; aceleași câmpuri, aceeași bifă GDPR (cu versiunea textului). */
export default function LoginFiord() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [gdprConsent, setGdprConsent] = useState(false);
  const [version, setVersion] = useState("");
  useEffect(() => { loadPlatformVersion().then(setVersion); }, []);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mfaToken, setMfaToken] = useState(null);   // al doilea pas (2FA)
  const [notice] = useState(() => takeLoginNotice());   // de ce am fost deconectat (parola s-a schimbat)

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (!gdprConsent) {
      setError("Trebuie să fii de acord cu prelucrarea datelor cu caracter personal (GDPR) pentru a continua.");
      return;
    }
    setLoading(true);
    try {
      const r = await login(username.trim().toLowerCase(), password, { gdprAccepted: gdprConsent });
      if (r?.mfa_required) setMfaToken(r); else nav("/");
    }
    catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally { setLoading(false); }
  };

  return (
    <div className="fiord-login" data-testid="login-fiord">
      <div className="fiord-login-card">
        <div className="fiord-login-brand"><img src={logo} alt="ONOMAD" /><div>Platforma de HR</div></div>
        {mfaToken ? <MfaCodeForm token={mfaToken.mfa_token} info={mfaToken} onDone={() => nav("/")} onBack={() => { setMfaToken(null); setPassword(""); }} /> : (
          <form onSubmit={submit} data-testid="login-form">
          {notice && <div style={{ background: "#FEF3C7", color: "#78350F", padding: "10px 14px", borderRadius: 8, marginBottom: 14, fontSize: 13 }} data-testid="login-notice">{notice}</div>}
            <h1>Autentificare</h1>
            <p className="fiord-login-sub">Introduceți datele de acces</p>
            <div style={{ marginBottom: 14 }}>
              <label className="label label-req">Utilizator</label>
              <input className="input" value={username} onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username" data-testid="login-username" />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label className="label label-req">Parolă</label>
              <PasswordInput value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" testId="login-password" />
            </div>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 16 }}>
              <input type="checkbox" checked={gdprConsent} onChange={e => setGdprConsent(e.target.checked)} id="gdpr-consent" data-testid="login-gdpr-consent" style={{ marginTop: 3, accentColor: "var(--f-acc)" }} />
              <label htmlFor="gdpr-consent" style={{ fontSize: 12.5, lineHeight: 1.45, cursor: "pointer", color: "var(--f-muted)" }}>
                Sunt de acord cu prelucrarea datelor mele cu caracter personal în conformitate cu Regulamentul (UE) 2016/679 (GDPR), în scopul autentificării și utilizării platformei.
                <span style={{ display: "block", fontSize: 11, opacity: .7, marginTop: 2 }} data-testid="gdpr-version">Textul acordului, versiunea {GDPR_TEXT_VERSION}</span>
              </label>
            </div>
            {error && <div className="fiord-login-error" data-testid="login-error">{error}</div>}
            <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }} disabled={loading} data-testid="login-submit">
              {loading ? "Se conectează..." : "Autentifică-te"}
            </button>
          </form>)}
        <div className="fiord-login-foot">© {new Date().getFullYear()} ONOMAD - Platforma de HR{version && ` | Versiunea ${version}`}</div>
      </div>
    </div>
  );
}
